import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_ai_generated_female_funnel~1
			funnel: {
				id: 'ob-ai-female-funnel',
				locale: ['en'],
			},
		},
	},
]

export default config
